import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../../utils';
import * as Core from '../../core';
import { i18n } from '../../i18n/translate';

export const FilterMenu = props => {
  const { children, className, ...extraProps } = props;

  return (
    <Core.Layout
      className={formatClassName([className, 'filter-menu'])}
      {...extraProps}
      boxShadow="md"
      borderRadius="xl"
      padding={'2xs'}
      marginTop={2}
      width="300px"
      zIndex={100}
    >
      <Core.Layout>
        <Core.Typography textStyle="p3" color="text-subdued" mx="sm" my="xs">
          {i18n.t('Filter')}
        </Core.Typography>
        {children}
      </Core.Layout>
    </Core.Layout>
  );
};

FilterMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
